import React from 'react'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import AnnouncementsLogs from '../../../_metronic/partials/widgets/tables/AnnouncementsLogs'
import { useIntl } from 'react-intl';
const dashboardBreadCrumbs: Array<PageLink> = [
    {
      title: 'Dashboard',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: 'Announcement Logs',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
  ];
function DashboardLogs() {
    const intl = useIntl();
  return (
    <>
         <PageTitle breadcrumbs={dashboardBreadCrumbs}>
       {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        </PageTitle>
        <AnnouncementsLogs />
    </>
  )
}

export default DashboardLogs